import { SecondaryButton } from "@client/content/shared/Buttons";
import Search from "@client/controls/Inputs/Search/component";
import { IconType } from "@client/types";
import { type Chat } from "@common/components/AiChat/types";
import { FormStyleContext } from "@common/contexts/FormStyle";
import { useI18n } from "@common/hooks/i18n";
import { sort } from "@common/lib/array";
import date from "@common/lib/date";
import * as React from "react";

type Props = {
  chats: Chat[];
  onBackClick: () => void;
  onChatClick: (id: string) => void;
};

const Chats = (props: Props) => {
  const i18n = useI18n();

  const { fieldStyle } = React.useContext(FormStyleContext);

  const [searchText, setSearchText] = React.useState("");
  const chats = React.useMemo(
    () =>
      sort(props.chats, { key: "startDate" }).filter((x) =>
        (x.shortDescription ?? "").toLowerCase().includes(searchText.toLowerCase())
      ),
    [props.chats, searchText]
  );

  return (
    <>
      <div className="chats_title">
        <SecondaryButton icon={IconType.ArrowLeft} onClick={props.onBackClick}>
          {i18n.back}
        </SecondaryButton>
        <Search onChange={setSearchText} onChangeTrigger={0} style={fieldStyle} value={searchText} />
      </div>
      {chats.map((x) => (
        <div key={x.chatId} className="chat_item" onClick={() => props.onChatClick(x.chatId)}>
          <div className="single-line-ellipsis">{x.shortDescription}</div>
          <div className="date">{date.formatDateTime(x.startDate)}</div>
        </div>
      ))}
    </>
  );
};

export default Chats;
